export { default } from './DotNetPlainWordmark'



// WEBPACK FOOTER //
// ../src/components/dot-net/plain-wordmark/index.js